module.exports = __webpack_public_path__ + "img/wheel.990b539f.jpeg";